import React from "react";
import { Stack } from "@mui/material";

import { DesiredPrompts } from "./DesiredPrompts/DesiredPrompts";
import { SelectedCommands } from "./SelectedCommands/SelectedCommands";
import { PromptLibrary } from "./PromptLibrary/PromptLibrary";
import { CommandsLibrary } from "./CommandsLibrary/CommandsLibrary";
import { TextTransformation } from "./TextTransformation/TextTransformation";
import { HistoryAndWorkflow } from "./HistoryAndWorkflow/HistoryAndWorkflow";

export const WBGifSections: React.FC = () => {
  return (
    <Stack
      width={1}
      direction="column"
      gap={16}
      sx={{
        gap: {
          md: 16,
          xs: 4,
        },
      }}
    >
      <TextTransformation />

      <DesiredPrompts />

      <SelectedCommands />

      <PromptLibrary />

      <CommandsLibrary />

      <HistoryAndWorkflow />
    </Stack>
  );
};
